// extracted by mini-css-extract-plugin
export default {"componentHolder":"EditProductsCategoryContainer_componentHolder__4Co7o","selectOptionsearch":"EditProductsCategoryContainer_selectOptionsearch__YjemR"};